var render = function (_h,_vm) {var _c=_vm._c;return _c('header',{key:_vm.data.key,staticClass:"my-header"},[_c('h1',[_vm._v("Scrollytelling Demo")]),_c('h1',[_vm._v("滚动叙事 示范")])])}
var staticRenderFns = []

export { render, staticRenderFns }